import { render, staticRenderFns } from "./changeEmailComplete.vue?vue&type=template&id=c5a1e012"
import script from "./changeEmailComplete.ts?vue&type=script&lang=js&external"
export * from "./changeEmailComplete.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports